import { Component, Mixins } from 'vue-property-decorator';
import { AppFiltersMixin } from '@/mixins/AppFiltersMixin';

@Component({
  validations: {
    akkoordVoorwaarden: {
      required: (value: boolean) => value === true
    }
  }
})
export default class AppAflossenHypotheekdeelExecute extends Mixins(AppFiltersMixin) {
  public akkoordVoorwaarden: boolean | null = null;

  pay() {
    this.$emit('pay');
  }
}
